import React, { Component, Fragment } from "react";

import { SellToWebAdminHeaderComponent } from "../common/selltowebheader/SellToWebAdminHeaderComponent";
import { SellToWebAdminFooterComponent } from "../common/selltowebfooter/SellToWebAdminFooterComponent";

export class SignOutRouteComponent extends Component {
    render() {
        return <Fragment>
            <SellToWebAdminHeaderComponent showLogo={true}/>
            <div className="app-signin">
                <p>You have been successfully logged out.</p>
            </div>
            <SellToWebAdminFooterComponent />
        </Fragment>;
    }
}